const IntegrationIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 43 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.75 2.5L37.5 16.5625M23.75 2.5V14.0625C23.75 15.4432 24.8693 16.5625 26.25 16.5625H37.5M23.75 2.5H10C5.85787 2.5 2.5 5.85787 2.5 10V40C2.5 44.1423 5.85787 47.5 10 47.5H17.5M37.5 16.5625V24.5312M32.5 32.5V40M32.5 40V47.5M32.5 40H25M32.5 40H40"
        stroke="#5A5A5A"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IntegrationIcon;
